export default "__VITE_ASSET__BEQchKZ4__"